export const listPolls = /* GraphQL */ `
  query listPolls {
    listPolls {
      items {
        owner
        createdAt
        firstImage
        firstLikieeId
        description
        expires
        id
        isActive
        secondImage
        secondLikieeId
        title
        votes {
          id
          owner
          vote
          pollId
        }
        first {
          url
        }
        second {
          url
        }
      }
    }
  }
`;

export const getPoll = /* GraphQL */ `
  query GetPoll($id: ID!) {
    getPoll(id: $id) {
      description
      createdAt
      expires
      firstImage
      firstLikieeId
      id
      isActive
      secondImage
      secondLikieeId
      title
      updatedAt
      owner
      votes {
        id
        owner
        vote
        pollId
      }
      first {
        url
      }
      second {
        url
      }
    }
  }
`;
